const REISEGIGANTEN_AFFILIATE_IDS: Readonly<string[]> = [
  'RGGSM001',
  'RGGREST001',
  'RGGAFB001',
  'RGGVii001',
  'RGGDES001',
  'RGGMLDVS',
];

const RANTAPALLO_AFFILIATE_IDS: Readonly<string[]> = ['Rantapallo'];

const ICELOLLY_AFFILIATE_IDS: Readonly<string[]> = ['ICELOLLY'];

const SKYSCANNER_META_PACKAGE_AFFILIATE_IDS: Readonly<string[]> = [
  'SKY001DE',
  'SKY001ES',
  'SKY001UK',
  'SKY001SE',
  'SKY001NO',
  'SKY001DK',
  'SKY001FR',
  'SKY001NL',
  'SKY001IT',
  'SKY001AT',
  'SKY001FI',
  'SKY001PT',
];

export function isReisegiganten(affiliateId: string | undefined): boolean {
  if (!affiliateId) {
    return false;
  }
  return REISEGIGANTEN_AFFILIATE_IDS.includes(affiliateId);
}

export function isRantapallo(affiliateId: string | undefined): boolean {
  if (!affiliateId) {
    return false;
  }
  return RANTAPALLO_AFFILIATE_IDS.includes(affiliateId);
}

export function isIcelolly(affiliateId: string | undefined): boolean {
  if (!affiliateId) {
    return false;
  }
  return ICELOLLY_AFFILIATE_IDS.includes(affiliateId);
}

export function isSkyscannerMetaPackage(
  affiliateId: string | undefined
): boolean {
  if (!affiliateId) {
    return false;
  }
  return SKYSCANNER_META_PACKAGE_AFFILIATE_IDS.includes(affiliateId);
}
